import { defineCapability } from './internal';
import { args } from '../common/args';

export const UPDATE_QUERY_PARAM_CAP = defineCapability({
  name: 'UPDATE_QUERY_PARAM_CAP' as const,
  args: {
    key: args.string(),
    value: args.optional(args.or(args.string(), args.arrayOf(args.string()))),
  },
});
